export default __webpack_public_path__ + "static/media/photo--lg--45.ce8bca6d.jpg";